// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#particles {\n  width: 100%;\n  height: 6.583333rem;\n  background-color: #e5e5e5;\n  z-index: 0;\n}", ""]);
// Exports
module.exports = exports;
